/**
 * Divider with Heading.
 *
 * @package
 */

/**
 * Internal dependencies.
 */
import Edit from './edit';

/**
 * WordPress Dependencies.
 */
import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	BlockEditorKeyboardShortcuts,
} from '@wordpress/block-editor';
import { 
	heading
} from '@wordpress/icons'; 
/**
 * Register block type.
 */
registerBlockType( 'ssvreutlingen-blocks/divider-heading', {

	apiVersion: 2,
	
	

	/**
	 * Block title.
	 *
	 * @type {string}
	 */
	title: __( 'SSV Trenner-Überschrift (h2)', 'ssvreutlingen' ),

	/**
	 * Block icon.
	 *
	 * @type {string}
	 */
	icon: heading,

	/**
	 * Block description.
	 *
	 * @type {string}
	 */
	description: __( 'Überschrift für Abschnitte', 'ssvreutlingen' ),

	/**
	 * Block category.
	 *
	 * @type {string}
	 */
	category: 'ssvreutlingen',
	anchor: true,
	/**
	 * Attributes.
	 */
	attributes: {
		option: {
			type: 'string',
			default: 'headline',
		},
		content: {
			type: 'string',
			source: 'html',
			selector: 'h2',
			default: __( 'Überschrift', 'ssvreutlingen' ),
		},
	},

	edit: Edit,

	/**
	 * Save function.
	 *
	 * @param {Object} props                    Props
	 *
	 * @param          props.attributes
	 * @param          props.attributes.content
	 * @return {Object} Content.
	 */
	save( { attributes: { content } } ) {
		console.warn( 'save', content );
		return (
			<div className="page__content-divider">
				<div className="page__content">
					<section className="page__content-subheadline text">
						<RichText.Content tagName="h2" value={ content } />
					</section>
				</div>
			</div>
		);
	},
} );
